module.exports = __webpack_public_path__ + "static/media/LOGO_MENU.657d6fb1.png";